import { connect } from 'react-redux';
import { SucursalesListado } from './SucursalesListado';
import { actions } from "../../../../../../redux/modules/empresas/empresas";

const ms2p = (state) => ({});

const md2p = { ...actions };

export default connect(ms2p, md2p)(SucursalesListado);
